/** CoStar.Api.Brokers.ViewModels.Detail.BrokerType */
export var BrokerType;
(function (BrokerType) {
    BrokerType[BrokerType["None"] = 0] = "None";
    BrokerType[BrokerType["InvestmentSale"] = 1] = "InvestmentSale";
    BrokerType[BrokerType["LandlordRep"] = 2] = "LandlordRep";
    BrokerType[BrokerType["TenantRep"] = 3] = "TenantRep";
})(BrokerType || (BrokerType = {}));
/** CoStar.Api.Brokers.ViewModels.Detail.BrokerLocationType */
export var BrokerLocationType;
(function (BrokerLocationType) {
    BrokerLocationType[BrokerLocationType["ThisLocation"] = 0] = "ThisLocation";
    BrokerLocationType[BrokerLocationType["SameMarket"] = 1] = "SameMarket";
    BrokerLocationType[BrokerLocationType["AllMarket"] = 2] = "AllMarket";
})(BrokerLocationType || (BrokerLocationType = {}));
